// External libraries
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';

// Zocdoc dependencies
import { Checkbox } from '@zocdoc-frontend-common/components-checkbox';
import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

export class ConfirmPrimaryCareView extends Component {
    static propTypes = {
        professionalName: PropTypes.string.isRequired,
        insuranceName: PropTypes.string.isRequired,
        insuranceType: PropTypes.string.isRequired,
        trackClickPrimaryCareWarning: PropTypes.func.isRequired,
    };

    render() {
        const {
            professionalName,
            insuranceName,
            invalidMessage,
            isChecked,
            onCheck,
            specialtyName,
            trackClickPrimaryCareWarning,
        } = this.props;

        return (
            <FormRow>
                <Checkbox
                    checked={isChecked}
                    invalidMessage={invalidMessage}
                    onChecked={value => {
                        onCheck(value);
                        trackClickPrimaryCareWarning();
                    }}
                >
                    <Confirmation data-test="primary-provider-confirmation">
                        {professionalName} is the {specialtyName} assigned to me
                        through {insuranceName}.
                    </Confirmation>
                </Checkbox>
            </FormRow>
        );
    }
}

const Confirmation = styled.span`
    font: 13px/20px ${FontFamily.SharpSansMedium};
`;
